import { j as r } from "./atoms-v218.js";
import { forwardRef as b } from "react";
import { CheckboxSkeleton as k } from "./atoms-v2112.js";
import { Label as C, Checkbox as u, Hover as E, ErrorContainer as g, ErrorIcon as I } from "./atoms-v2113.js";
import { InputContainer as R } from "./atoms-v2114.js";
const v = b(
  ({
    ariaHidden: h = !1,
    ariaLabel: x,
    className: c,
    colorTheme: o = "light",
    defaultChecked: l,
    disabled: i,
    error: t,
    id: n,
    isSkeleton: a = !1,
    label: d,
    name: e,
    onChange: m,
    readOnly: s,
    ...f
  }, p) => {
    if (a)
      return /* @__PURE__ */ r.jsx(k, { ariaLabel: x, className: c, id: n, name: e });
    const $ = !!t, j = `${e}_errormessage`;
    return /* @__PURE__ */ r.jsxs(R, { className: c, children: [
      /* @__PURE__ */ r.jsxs(
        C,
        {
          $colorTheme: o,
          $isDisabled: i,
          $isReadonly: s,
          "aria-hidden": h,
          "aria-label": x,
          htmlFor: n || e,
          children: [
            /* @__PURE__ */ r.jsx(
              u,
              {
                $colorTheme: o,
                $isErrored: $,
                defaultChecked: l,
                disabled: i || s,
                id: n || e,
                name: e,
                onChange: m,
                readOnly: s,
                ref: p,
                type: "checkbox",
                ...f
              }
            ),
            !i && !s ? /* @__PURE__ */ r.jsx(E, { "aria-hidden": !0, $colorTheme: o, "data-testid": "checkbox-hover" }) : null,
            d
          ]
        }
      ),
      t && /* @__PURE__ */ r.jsxs(g, { $colorTheme: o, id: j, children: [
        /* @__PURE__ */ r.jsx(I, { $colorTheme: o, name: "warning-filled", size: "small" }),
        t
      ] })
    ] });
  }
);
v.displayName = "Checkbox";
export {
  v as Checkbox
};
